module.exports = __webpack_public_path__ + "static/media/realtors-icon-5.250b79a2.svg";